/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'app/utils/loadable';

export const RegistrationPage = lazyLoad(
  () => import('./index'),
  module => module.RegistrationPage,
);
